export const coursesData = [
  {
    id: 1,
    title: "Flutter + Firebase",
    description: "Learn to build cross-platform mobile applications with Flutter and integrate Firebase for backend services.",
    image: "flutter_firebase.png",
    features: [
      "Cross-platform app development",
      "Firebase Authentication",
      "Cloud Firestore",
      "Real-time Database",
      "Firebase Storage",
      "State Management",
      "Responsive UI Design"
    ],
    duration: "12 weeks/6 months",
    level: "Beginner to Advanced"
  },
  {
    id: 2,
    title: "MERN Stack (Full Stack)",
    description: "Become a full-stack developer with MongoDB, Express.js, React.js, and Node.js.",
    image: "mern_stack.webp", // Using the same image as placeholder
    features: [
      "MongoDB Database",
      "Express.js Backend",
      "React.js Frontend",
      "Node.js Server",
      "RESTful API Development",
      "JWT Authentication",
      "Responsive Web Design"
    ],
    duration: "16 weeks/6 months",
    level: "Intermediate"
  },
  {
    id: 3,
    title: "3ds Max + V-ray",
    description: "Master 3D modeling, animation, and photorealistic rendering with 3ds Max and V-ray.",
    image: "vray.png", // Using the same image as placeholder
    features: [
      "3D Modeling Fundamentals",
      "Advanced Modeling Techniques",
      "Texturing and Materials",
      "Lighting and Rendering",
      "V-ray Integration",
      "Photorealistic Rendering",
      "Animation Principles"
    ],
    duration: "14 weeks/6 months",
    level: "Beginner to Intermediate"
  }
];
